import React, { useState } from 'react'
import {
  Col, Upload, Select, Input, DatePicker, Checkbox, Radio,
} from 'antd'
import { Query } from 'react-apollo'
import { useQuery } from '@apollo/react-hooks'
import moment from 'moment'
import * as UI from 'konsys-ui'
import _ from 'lodash'
import numeral from 'numeral'
import { detailMode, repairJobType, status } from '../constants'
import { checkInt, checkSpecial, checkFloat } from '../../../utils/util-services'
import { AddGarageModal, InputWithLabelInt, InputWithLabelBlock } from '../../../components/repair-job-components'
import { colorSelector, textSelector } from '../util-functions'
import { theme } from '../../../styles/_variables'
import { MYINFO } from '../../../constants/graph/query'
import { GET_GARAGE_LIST, GET_TRAILER_LIST } from '../../../constants/graphql/query'
import { statusColor, statusText } from '../../truck-page/constants'
import { UploadWithModal } from '../../../components/common'

/*
date.type is type of component
1: Select
5: Upload box
7: Text area
8: Datepicker
9: Int input
*/

const truckTypeSelector = (value) => {
  switch (value) {
    case 'PADOONGRICH':
      return 'ผดุงฤทธิ์'
    case 'JOINTCAR':
      return 'รถร่วมในเครือ'
    case 'OUTJOINTCAR':
      return 'รถร่วมนอก'
    default: return 'ไม่ระบุ'
  }
}

const CreateMode = ({
  data, onChangeHandler, mutationVariables, plateHandler, garageHandler, trailerHandler,
}) => {
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span} offset={data.offset}>
        </Col>
      )
    case 1: // Platenumber
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.P {...data.props} display='block' margin='0 0 16px'>{data.label}</UI.P>
          <UI.Div display='flex' alignItems='center'>
            <Select
              showSearch
              style={{ width: '50%' }}
              loading={plateHandler.loading}
              onSelect={(e) => {
                const selected = _.find(plateHandler.TruckList.lists, o => o.plateNumber === e)
                const isHaveTrailer = (selected && selected.trailer && selected && selected.trailer.trailerPlate ? {
                  id: selected.trailer.id,
                  trailerPlate: selected.trailer.trailerPlate,
                  status: selected.trailer.status,
                } : {
                  id: null,
                  trailerPlate: null,
                  status: null,
                })
                const extra = {
                  driver: selected.driver.id,
                  phoneNumber: selected.driver.phonenumber,
                  trailerId: isHaveTrailer.id,
                  isRepairTruck: true,
                  isRepairTrailer: (!_.isNull(isHaveTrailer.id)),
                }
                onChangeHandler(data.id, selected.id, extra)
                plateHandler.setTruckSelected(selected)
                plateHandler.setDriverSelected(selected.driver)
                plateHandler.setPhoneNumber(selected.driver.phonenumber)
                if (trailerHandler.disableTrailer === false) {
                  if (isHaveTrailer.id) {
                    trailerHandler.setTrailerSelected({
                      ...isHaveTrailer,
                    })
                  } else {
                    trailerHandler.setTrailerSelected({})
                  }
                }
              }}
              onSearch={e => plateHandler.setPlatenumberSearch(e)}
              placeholder='พิมพ์เพื่อค้นหา'
            >
              {
                plateHandler.TruckList.lists.map(v => <Select.Option key={v.id} value={v.plateNumber}>{v.plateNumber}</Select.Option>)
              }
            </Select>
            <UI.Div>
              {
                _.isEmpty(plateHandler.truckSelected)
                  ? ''
                  : <UI.Div {...data.props} display='block'>
                    <UI.P bold margin='0 10px 0 16px'>
                      เจ้าของ:
                    </UI.P>
                    <UI.P>
                      {truckTypeSelector(plateHandler.truckSelected.owner.type)}
                    </UI.P>
                  </UI.Div>
              }
              {_.isEmpty(plateHandler.truckSelected)
                ? ''
                : <UI.Div {...data.props} display='block' margin='5px 0 0 0' >
                  <UI.P bold margin='0 10px 0 16px'>
                    สถานะ:
                  </UI.P>
                  <UI.P>
                    {statusText[plateHandler.truckSelected.status]}
                  </UI.P>
                </UI.Div>
              }
            </UI.Div>
          </UI.Div>
        </Col>
      )
    case 1.1: // Platenumber
      {
        const [trailerPlateNumberSearch, setTrailerPlatenumberSearch] = useState('')
        return (
          <Col span={data.span} offset={data.offset} style={data.props.style}>
            <UI.P display='block' margin='0 0 16px'>{data.label}</UI.P>
            <UI.Div display='flex' alignItems='center'>
              <Query
                query={GET_TRAILER_LIST}
                fetchPolicy='network-only'
                variables={{ trailerPlate: trailerPlateNumberSearch }}
              >{(trailerResp) => {
                if (trailerResp.loading && _.isUndefined(trailerResp.data.TrailerList)) return <UI.Loading />
                if (trailerResp.error) return <UI.P>เกิดข้อผิดพลาด</UI.P>
                return (
                  <Select
                    showSearch
                    disabled={trailerHandler.disableTrailer}
                    style={{ width: '100%' }}
                    defaultValue={trailerHandler.trailerSelected ? trailerHandler.trailerSelected.trailerPlate : null}
                    value={trailerHandler.trailerSelected ? trailerHandler.trailerSelected.trailerPlate : null}
                    onSelect={(e) => {
                      const selected = _.find(trailerResp.data.TrailerList.lists, o => o.trailerPlate === e)
                      onChangeHandler(data.id, selected.id)
                      trailerHandler.setTrailerSelected(selected)
                    }}
                    onSearch={e => setTrailerPlatenumberSearch(e)}
                    placeholder='พิมพ์เพื่อค้นหา'
                  >
                    {
                      trailerResp.data.TrailerList.lists.map(v => <Select.Option key={v.id} value={v.trailerPlate}>{v.trailerPlate}</Select.Option>)
                    }
                  </Select>
                )
              }}
              </Query>
            </UI.Div>
          </Col>
        )
      }
    case 1.2:
      return (<Col span={data.span} offset={data.offset}>
        <div className='h-[calc(100%-32px)] border-r my-4 mr-4' style={{ borderColor: theme.color.paleGrey }}>
          <Checkbox
            defaultChecked={data.id === 'isRepairTruck' || (mutationVariables[data.id] === true)}
            onChange={e => onChangeHandler(data.id, e.target.checked)} style={{ margin: '0 0 16px 0' }}>{data.label}</Checkbox>
        </div>
      </Col>)
    case 2:
      return (
        <Col
          span={data.span} offset={data.offset}
          style={{ margin: data.props.margin }}
        >
          <UI.Div>
            <InputWithLabelBlock
              isFloat={true}
              data={{
                unit: data.unit,
                // disabled,
                // value: disabled ? numeral(totalAmount).format('0,0.00') : totalAmount,
                id: data.id,
                props: { margin: '0 8px 16px 0', width: '100%', title: { text: data.label } },
              }}
              onChangeHandler={onChangeHandler}
            />
          </UI.Div>
        </Col>
      )
    case 1.3:
      return (
        <Col span={data.span} offset={data.offset} style={data.props.style}>
          <UI.Div>
            <UI.P display='block' margin='0 0 16px 0'>
              สถานะหางพ่วง
            </UI.P>
            {_.isEmpty(trailerHandler.trailerSelected)
              ? '-'
              : <UI.Div {...data.props} display='block' margin='5px 0 10px 0' >
                <UI.P bold color={statusColor[trailerHandler.trailerSelected.status]}>
                  {statusText[trailerHandler.trailerSelected.status]}
                </UI.P>
              </UI.Div>
            }
          </UI.Div>
        </Col>
      )
    case 3.1:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <UI.P display='flex' margin='6px 0'>{_.isEmpty(plateHandler.truckSelected) ? '' : plateHandler.truckSelected.type.nameTh}</UI.P>
          </UI.Div>
        </Col>
      )
    case 3.2:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Select
              showSearch
              defaultValue={_.isEmpty(plateHandler.truckSelected) ? '' : plateHandler.truckSelected.driver.fullname}
              style={{ width: '100%' }}
              value={plateHandler.driverSelected.fullname}
              loading={plateHandler.loadingDriver}
              filterOption={(input, option) => option.props.name.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              onSelect={(e) => {
                const selected = _.find(plateHandler.DriverList.lists, o => o.id === e)
                const phoneNumber = {
                  id: 'phoneNumber',
                  value: !_.isNull(selected.phonenumber) ? selected.phonenumber : '',
                }
                onChangeHandler('driverId', selected.id, phoneNumber)
                plateHandler.setDriverSelected(selected)
                plateHandler.setPhoneNumber(selected.phonenumber)
              }}
              onSearch={e => plateHandler.setDriverSearch(e)}
              placeholder='พิมพ์เพื่อค้นหา'
            >
              {
                plateHandler.DriverList.lists.map(v => <Select.Option key={v.id} value={v.id} name={v.fullname}>{v.fullname}</Select.Option>)
              }
            </Select>
          </UI.Div>
        </Col>
      )
    case 3.3:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Input
              value={plateHandler.phoneNumber}
              style={{ margin: '0 8px 16px 0', width: '100%' }}
              onChange={(e) => {
                plateHandler.setPhoneNumber(e.target.value)
                onChangeHandler(data.id, e.target.value)
              }}
            />
          </UI.Div>
        </Col>
      )
    case 5:
      return (
        <Col span={data.span} offset={data.offset}>
          <UploadWithModal
            onChange={e => onChangeHandler(data.id, e.fileList.map(v => v.originFileObj))}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            button={data.props}
            listType='picture'
          />
        </Col>
      )
    case 7:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.P {...data.props} display='block' margin='0 0 16px'>{data.label}</UI.P>
          <Input.TextArea rows={4} style={{ margin: '0 0 16px' }} onChange={e => onChangeHandler(data.id, e.target.value)} />
        </Col>
      )
    case 8:
      return (
        <Col
          span={data.span} offset={data.offset}
          style={{ margin: data.props.margin }}
        >
          <UI.Div display='flex' flexDirection='column' margin='0'>
            <UI.P margin='0 0 16px'>{data.label}</UI.P>
            <DatePicker onChange={e => onChangeHandler(data.id, moment(e).format('YYYY-MM-DD'))} style={{ marginBottom: 16 }} />
          </UI.Div>
        </Col>
      )
    case 9:
      return (
        <Col
          span={data.span} offset={data.offset}
          style={{ margin: data.props.margin }}
        >
          <UI.Div>
            <InputWithLabelInt
              isInt={true}
              data={{
                unit: data.unit,
                id: data.id,
                props: { margin: '0 8px 16px 0', width: '100%', title: { text: data.label } },
              }}
              onChangeHandler={onChangeHandler}
            />
          </UI.Div>
        </Col>
      )
    case 9.1:
      return (
        <Col
          span={data.span} offset={data.offset}
          style={{ margin: data.props.margin }}
        >
          <UI.Div>
            <InputWithLabelBlock
              isFloat={true}
              data={{
                unit: data.unit,
                disabled: (!(mutationVariables.outsourceType === 'SERVICECENTER') || _.isUndefined(mutationVariables.garageId) || !(mutationVariables.isOutsource)),
                value: mutationVariables[data.id],
                id: data.id,
                props: { margin: '0 8px 16px 0', width: '100%', title: { text: data.label } },
              }}
              onChangeHandler={onChangeHandler}
            />
          </UI.Div>
        </Col>
      )
    case 9.2:
      return (
        <Col
          span={data.span} offset={data.offset}
          style={{ margin: data.props.margin }}
        >
          <UI.Div>
            <InputWithLabelBlock
              isFloat={true}
              data={{
                unit: data.unit,
                disabled: true,
                id: data.id,
                props: { margin: '0 8px 16px 0', width: '100%', title: { text: data.label } },
              }}
              onChangeHandler={onChangeHandler}
            />
          </UI.Div>
        </Col>
      )
    case 9.3:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Select
              showSearch
              style={{ width: '100%' }}
              disabled={true}
              placeholder='พิมพ์เพื่อค้นหา'
            >
              {
                plateHandler?.DriverList?.lists?.map(v => <Select.Option key={v.id} value={v.id} name={v.fullname}>{v.fullname}</Select.Option>)
              }
            </Select>
          </UI.Div>
        </Col>
      )
    case 10: {
      const [addGarageModal, setAddGarageModal] = useState(false)
      return (
        <Col
          span={data.span} offset={data.offset}
          style={{ margin: data.props.margin }}
        >
          <UI.Div>
            <Checkbox onChange={e => onChangeHandler('isOutsource', e.target.checked)} style={{ margin: '0 0 16px 0' }}>ซ่อมข้างนอก</Checkbox>
            <br />
            {
              mutationVariables.isOutsource
              && <UI.Div>
                {
                  <Query
                    query={GET_GARAGE_LIST}
                    fetchPolicy='cache-and-network'
                    variables={{ name: garageHandler.garageSearch }}
                  >{({ data: garageData, loading, error }) => {
                    if (loading && _.isEmpty(garageData)) return <UI.Loading center='true' />
                    if (error) return <UI.P>เกิดข้อผิดพลาด</UI.P>
                    const garageList = garageData.GarageList.lists
                    return <UI.Div>
                      <Radio.Group value={mutationVariables.outsourceType} onChange={(e) => {
                        onChangeHandler('outsourceType', e.target.value)
                      }}>
                        <Radio value='SERVICECENTER'>ส่งไปอู่นอก / ศูนย์บริการ</Radio>
                        <Radio value='OUTSOURCE'>งานนอก (ช่างเบิกไปซ่อมข้างนอก)</Radio>
                      </Radio.Group>
                      <br />
                      {mutationVariables.outsourceType === 'SERVICECENTER'
                        && <UI.Div>
                          <UI.Div display='flex' alignItems='center'>
                            <UI.P margin='24px 16px 16px 0'>ชื่อศูนย์บริการ *</UI.P>
                            <Select
                              showSearch
                              style={{ width: '40%' }}
                              value={garageHandler.garageSelected.name}
                              loading={loading}
                              onSelect={(e) => {
                                const selected = _.find(garageData.GarageList.lists, o => o.name === e)
                                onChangeHandler('garageId', selected.id)
                                garageHandler.setGarageSelected(selected)
                              }}
                              onSearch={e => garageHandler.setGarageSearch(e)}
                              placeholder='พิมพ์เพื่อค้นหา'
                            >
                              {
                                garageList.map(v => <Select.Option key={v.id} value={v.name}>{v.name}</Select.Option>)
                              }
                            </Select>
                            <UI.Button
                              margin='0 0 0 16px'
                              text={'เพิ่มศูนย์บริการ'}
                              icon={'fas fa-plus'}
                              onClick={() => setAddGarageModal(true)}
                            />
                          </UI.Div>
                          <UI.Div><UI.P margin='0 16px 16px 0'>เบอร์โทร</UI.P><UI.P>{garageHandler.garageSelected.phoneNumber}</UI.P></UI.Div>
                          <UI.Div><UI.P margin='0 16px 16px 0'>ที่อยู่</UI.P><UI.P>{!_.isNull(garageHandler.garageSelected.address) ? garageHandler.garageSelected.address : 'ไม่มีข้อมูลที่อยู่ของศูนย์บริการนี้'}</UI.P></UI.Div>
                        </UI.Div>
                      }
                      <UI.Div margin={mutationVariables.outsourceType === 'SERVICECENTER' ? '0' : '16px 0 0 0'}><UI.P margin='0 16px 16px 0'>หมายเหตุ</UI.P><UI.Input value={mutationVariables.outsourceRemark} width='50%' onChange={e => onChangeHandler('outsourceRemark', e.target.value)} /></UI.Div>
                      <AddGarageModal addGarageModal={addGarageModal} setAddGarageModal={setAddGarageModal} />
                    </UI.Div>
                  }}</Query>}
              </UI.Div>
            }
          </UI.Div>
        </Col>
      )
    }
    case 11:
      return (
        <Col span={data.span} offset={data.offset}>
        </Col>
      )
    case 12:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Select
              style={{ width: '100%' }}
              onSelect={(e) => {
                onChangeHandler(data.id, e)
              }}
              defaultValue={false}
            >
              <Select.Option key={1} value={false}>รถเข้าอู่</Select.Option>
              <Select.Option key={2} value={true}>รถยังไม่เข้าอู่</Select.Option>
            </Select>
          </UI.Div>
        </Col>
      )
    case 13: {
      const {
        data: myInfo, loading, error, fetchMore, refetch,
      } = useQuery(MYINFO)
      if (loading || _.isEmpty(myInfo)) return <UI.Loading center='true' />
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Select
              style={{ width: '100%' }}
              onSelect={(e) => {
                onChangeHandler(data.id, e)
              }}
            >
              {
                myInfo.myInfo.Warehouses.map(v => <Select.Option key={v.id} value={v.id}>{v.warehouseName}</Select.Option>)
              }
            </Select>
          </UI.Div>
        </Col>
      )
    }
    case 14:
      return (
        <Col
          span={data.span} offset={data.offset}
          style={{ margin: data.props.margin }}
        >
          <UI.Div>
            <InputWithLabelBlock
              isFloat={true}
              data={{
                unit: data.unit,
                // value: disabled ? numeral(totalAmount).format('0,0.00') : totalAmount,
                id: data.id,
                props: { margin: '0 8px 16px 0', width: '100%', title: { text: data.label } },
              }}
              onChangeHandler={onChangeHandler}
            />
          </UI.Div>
        </Col>
      )
    case 14.1:
      return (
        <Col span={data.span} offset={data.offset}>
        </Col>
      )
    case 14.2:
      return (
        <Col span={data.span} offset={data.offset}>
        </Col>
      )
    case 14.3:
      return (
        <Col span={data.span} offset={data.offset}>
        </Col>
      )
    case 15:
      return (
        <Col span={data.span} offset={data.offset} style={data.props.style}>
          <UI.Div>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Select
              style={{ width: '100%' }}
              onSelect={(e) => {
                onChangeHandler(data.id, e)
              }}
              disabled={!mutationVariables[data.enableKey]}
            >
              {Object.keys(repairJobType).map(type => (
                <Select.Option value={repairJobType[type].value} key={repairJobType[type].value}>
                  {repairJobType[type].label}
                </Select.Option>
              ))}
            </Select>
          </UI.Div>
        </Col>
      )
    case 16:
      return (
        <Col span={data.span} offset={data.offset} style={data.props.style}>
          <UI.Div>
            <InputWithLabelBlock
              data={{
                disabled: !(
                  mutationVariables[data.enableKey]
                  && mutationVariables[data.enableOtherKey] === repairJobType.OTHER.value
                ),
                value: mutationVariables[data.id],
                id: data.id,
                props: { margin: '0 8px 16px 0', width: '100%', title: { text: data.label } },
              }}
              onChangeHandler={onChangeHandler}
            />
          </UI.Div>
        </Col>
      )
    case 17:
      return (
        <Col
          span={24}
          style={{
            height: '1px',
            width: '100%',
            backgroundColor: theme.color.paleGrey,
            marginBlock: '40px',
          }}
        />
      )
    case 18:
      return (
        <Col span={24}>
          <UI.P>ประเภทของการซ่อม</UI.P>
        </Col>
      )
    default:
      return <p>No type</p>
  }
}


const EditMode = ({
  data, disabled, initialData, onChangeHandler, plateHandler, mutationVariables, garageHandler, trailerHandler,
}) => {
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.H4 bold>{data.label}: {initialData[data.id]}</UI.H4>
          <br />
          <UI.H4>สถานะ:</UI.H4>
          <UI.H4 bold margin='0 0 0 4px' color={colorSelector(initialData.status)}>{textSelector(initialData.status)}</UI.H4>
        </Col>
      )
    case 1: // Platenumber
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.P {...data.props} display='block' margin='0 0 16px'>{data.label}</UI.P>
          <UI.Div display='flex' alignItems='center'>
            <Select
              showSearch
              defaultValue={initialData.Truck.plateNumber}
              style={{ width: '50%' }}
              loading={plateHandler.loading}
              onSelect={(e) => {
                const selected = _.find(plateHandler.TruckList.lists, o => o.plateNumber === e)
                const isHaveTrailer = (selected && selected.trailer && selected && selected.trailer.trailerPlate ? {
                  id: selected.trailer.id,
                  trailerPlate: selected.trailer.trailerPlate,
                } : {
                  id: null,
                  trailerPlate: null,
                })
                const extra = {
                  driver: selected.driver.id,
                  phoneNumber: selected.driver.phonenumber,
                }
                onChangeHandler(data.id, selected.id, extra)
                plateHandler.setTruckSelected(selected)
                plateHandler.setDriverSelected(selected.driver)
                plateHandler.setPhoneNumber(selected.driver.phonenumber)
                if (trailerHandler.disableTrailer === false) {
                  if (isHaveTrailer.id) {
                    trailerHandler.setTrailerSelected({
                      ...isHaveTrailer,
                    })
                  } else {
                    trailerHandler.setTrailerSelected({})
                  }
                }
              }}
              onSearch={e => plateHandler.setPlatenumberSearch(e)}
              placeholder='พิมพ์เพื่อค้นหา'
              disabled={disabled || data.disabled}
            >
              {
                plateHandler.TruckList.lists.map(v => <Select.Option key={v.id} value={v.plateNumber}>{v.plateNumber}</Select.Option>)
              }
            </Select>
            <UI.Div>
              {
                <UI.Div {...data.props} display='block'>
                  <UI.P bold margin='0 10px 0 16px'>
                    เจ้าของ:
                  </UI.P>
                  <UI.P>
                    {
                      (initialData && initialData.Truck && initialData.Truck.owner && truckTypeSelector(initialData.Truck.owner.type)) || 'ไม่ระบุ'
                    }
                  </UI.P>
                </UI.Div>
              }
              {
                <UI.Div {...data.props} display='block' margin='5px 0 0 0' >
                  <UI.P bold margin='0 10px 0 16px'>
                    สถานะ:
                  </UI.P>
                  <UI.P>
                    {
                      (initialData && initialData.Truck && initialData.Truck.status && statusText[initialData.Truck.status]) || 'ไม่ระบุ'
                    }
                  </UI.P>
                </UI.Div>
              }
            </UI.Div>
          </UI.Div>
        </Col>
      )
    case 1.1: // Trailer
      return (
        <Col span={data.span} offset={data.offset} style={data.props.style}>
          <UI.Div display='block' alignItems='center'>
            <UI.P display='block' margin='0 0 16px 0'>{data.label}</UI.P>
            <Query
              query={GET_TRAILER_LIST}
              fetchPolicy='network-only'
              // defaultValue={initialData.Trailer.plateNumber}
              variables={{ trailerPlate: trailerHandler.trailerPlateNumberSearch }}
            >{(trailerResp) => {
              if (!trailerResp.loading && !_.isUndefined(trailerResp.data.TrailerList.lists)) {
                trailerHandler.setTrailers(trailerResp.data.TrailerList.lists)
              }
              return ''
            }}
            </Query>
            <Select
              showSearch
              style={{ width: '100%' }}
              defaultValue={initialData && initialData.Trailer && initialData.Trailer.trailerPlate ? initialData.Trailer.trailerPlate : null}
              onSelect={(e) => {
                const selected = _.find(trailerHandler.TrailerList, o => o.trailerPlate === e)
                onChangeHandler(data.id, selected.id)
                trailerHandler.setTrailerSelected(selected)
              }}
              onSearch={e => trailerHandler.setTrailerPlatenumberSearch(e)}
              placeholder='พิมพ์เพื่อค้นหา'
              disabled={disabled || data.disabled}
            >
              {
                trailerHandler.TrailerList.map(v => <Select.Option key={v.id} value={v.trailerPlate}>{v.trailerPlate}</Select.Option>)
              }
            </Select>
          </UI.Div>
        </Col>
      )
    case 1.2:
      return (<Col span={data.span} offset={data.offset}>
        <div className='w-full border-r border-gray'>
          <Checkbox
            defaultChecked={initialData[data.id]}
            disabled={disabled || data.disabled}
            onChange={e => onChangeHandler(data.id, e.target.checked)} style={{ margin: '0 0 16px 0' }}>{data.label}</Checkbox>
        </div>
      </Col>)
    case 1.3:
      return (
        <Col span={data.span} offset={data.offset} style={data.props.style}>
          <UI.Div>
            <UI.P display='block' margin='0 0 16px 0'>
              สถานะหางพ่วง
            </UI.P>
            {
              initialData && initialData.Trailer && initialData.Trailer.status
                ? (
                  <UI.Div {...data.props} display='block' margin='5px 0 10px 0' >
                    <UI.P bold color={statusColor[initialData.Trailer.status]}>
                      {statusText[initialData.Trailer.status]}
                    </UI.P>
                  </UI.Div>
                )
                : '-'
            }
          </UI.Div>
        </Col>
      )
    case 3.1:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <UI.P display='flex' margin='6px 0'>{_.isEmpty(plateHandler.truckSelected) ? initialData.Truck.type.nameTh : plateHandler.truckSelected.type.nameTh}</UI.P>
          </UI.Div>
        </Col>
      )
    case 3.2:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Select
              showSearch
              defaultValue={_.isEmpty(plateHandler.truckSelected) ? initialData.Driver ? initialData.Driver.fullname : '' : plateHandler.truckSelected.type.nameTh}
              style={{ width: '100%' }}
              loading={plateHandler.loadingDriver}
              filterOption={(input, option) => option.props.name.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              onSelect={(e) => {
                const selected = _.find(plateHandler.DriverList.lists, o => o.id === e)
                const phoneNumber = {
                  id: 'phoneNumber',
                  value: !_.isNull(selected.phonenumber) ? selected.phonenumber : '',
                }
                onChangeHandler('driverId', selected.id, phoneNumber)
                plateHandler.setDriverSelected(selected)
                plateHandler.setPhoneNumber(selected.phonenumber)
              }}
              onSearch={e => plateHandler.setDriverSearch(e)}
              disabled={disabled || data.disabled}
              placeholder='พิมพ์เพื่อค้นหา'
            >
              {
                plateHandler.DriverList.lists.map(v => <Select.Option key={v.id} value={v.id} name={v.fullname}>{v.fullname}</Select.Option>)
              }
            </Select>
          </UI.Div>
        </Col>
      )
    case 3.3:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Input
              style={{ margin: '0 8px 16px 0', width: '100%' }}
              defaultValue={initialData.phoneNumber}
              value={!_.isUndefined(plateHandler.phoneNumber) ? plateHandler.phoneNumber : initialData.phoneNumber}
              onChange={(e) => {
                plateHandler.setPhoneNumber(e.target.value)
                onChangeHandler(data.id, e.target.value)
              }}
              disabled={disabled || data.disabled}
            />
          </UI.Div>
        </Col>
      )
    case 5:
      return (
        <Col span={data.span} offset={data.offset}>
          <UploadWithModal
            defaultFileList={initialData[data.id].map(v => ({
              name: v.filename,
              url: v.url,
              uid: v.url,
            }))}
            onChange={e => onChangeHandler(data.id, e.fileList.map(v => (v.url ? { url: v.url } : v.originFileObj)))}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            button={data.props}
            listType='picture'
          />
        </Col>
      )
    case 7:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.P {...data.props} display='block' margin='0 0 16px'>{data.label}</UI.P>
          <Input.TextArea disabled={disabled} rows={4} style={{ margin: '0 0 16px' }} defaultValue={initialData[data.id]} onChange={e => onChangeHandler(data.id, e.target.value)} />
        </Col>
      )
    case 8:
      return (
        <Col
          span={data.span} offset={data.offset}
          style={{ margin: data.props.margin }}
        >
          <UI.Div display='flex' flexDirection='column' margin='0'>
            <UI.P margin='0 0 16px'>{data.label}</UI.P>
            <DatePicker disabled={disabled} onChange={e => onChangeHandler(data.id, moment(e).format('YYYY-MM-DD'))} defaultValue={moment(initialData[data.id])} style={{ marginBottom: 16 }} />
          </UI.Div>
        </Col>
      )
    case 9:
      return (
        <Col
          span={data.span} offset={data.offset}
          style={{ margin: data.props.margin }}
        >
          <UI.Div>
            <InputWithLabelInt
              isInt={true}
              data={{
                unit: data.unit,
                defaultValue: initialData[data.id],
                disabled,
                // value: disabled ? numeral(totalAmount).format('0,0.00') : totalAmount,
                id: data.id,
                props: { margin: '0 8px 16px 0', width: '100%', title: { text: data.label } },
              }}
              onChangeHandler={onChangeHandler}
            />
          </UI.Div>
        </Col>
      )
    case 9.1:
      return (
        <Col
          span={data.span} offset={data.offset}
          style={{ margin: data.props.margin }}
        >
          <UI.Div>
            <InputWithLabelBlock
              isFloat={true}
              data={{
                unit: data.unit,
                defaultValue: initialData[data.id],
                disabled: disabled || !(initialData.Garage),
                value: mutationVariables[data.id],
                id: data.id,
                props: { margin: '0 8px 16px 0', width: '100%', title: { text: data.label } },
              }}
              onChangeHandler={onChangeHandler}
            />
          </UI.Div>
        </Col>
      )
    case 9.2:
      return (
        <Col
          span={data.span} offset={data.offset}
          style={{ margin: data.props.margin }}
        >
          <UI.Div>
            <InputWithLabelBlock
              isFloat={true}
              data={{
                unit: data.unit,
                defaultValue: initialData[data.id],
                disabled: disabled || _.findIndex(initialData.services, { serviceType: 'TIRE' }) < 0 || (_.isNull(initialData.TireCarrierDriver) && _.isUndefined(mutationVariables.tireCarrierDriverId)),
                id: data.id,
                props: { margin: '0 8px 16px 0', width: '100%', title: { text: data.label } },
              }}
              onChangeHandler={onChangeHandler}
            />
          </UI.Div>
        </Col>
      )

    case 9.3:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Select
              showSearch
              defaultValue={initialData.TireCarrierDriver ? initialData.TireCarrierDriver.fullname : ''}
              style={{ width: '100%' }}
              loading={plateHandler.loadingDriver}
              filterOption={(input, option) => option.props.name.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              onSelect={(e) => {
                onChangeHandler(data.id, e)
                plateHandler.setDriverSearch()
              }}
              onSearch={e => plateHandler.setDriverSearch(e)}
              disabled={disabled || data.disabled || _.findIndex(initialData.services, { serviceType: 'TIRE' }) < 0}
              placeholder='พิมพ์เพื่อค้นหา'
            >
              {
                plateHandler?.DriverList?.lists?.map(v => <Select.Option key={v.id} value={v.id} name={v.fullname}>{v.fullname}</Select.Option>)
              }
            </Select>
          </UI.Div>
        </Col>
      )
    case 10:
      return (
        <Col
          span={data.span} offset={data.offset}
          style={{ margin: data.props.margin }}
        >
          <UI.Div>
            <Checkbox disabled={true} defaultChecked={initialData.isOutsource} onChange={e => onChangeHandler('isOutsource', e.target.checked)} style={{ margin: '0 0 16px 0' }}>ซ่อมข้างนอก</Checkbox>
            <br />
            {
              (_.isUndefined(mutationVariables.isOutsource) ? initialData.isOutsource : mutationVariables.isOutsource)
              && <UI.Div>
                {
                  <Query
                    query={GET_GARAGE_LIST}
                    fetchPolicy='cache-and-network'
                    variables={{ name: garageHandler.garageSearch }}
                  >{({ data: garageData, loading, error }) => {
                    if (loading && _.isEmpty(garageData)) return <UI.Loading center='true' />
                    if (error) return <UI.P>เกิดข้อผิดพลาด</UI.P>
                    const garageList = garageData.GarageList.lists
                    return <UI.Div>
                      <Radio.Group disabled={true} defaultValue={initialData.outsourceType} onChange={e => onChangeHandler('outsourceType', e.target.value)}>
                        <Radio value='SERVICECENTER'>ส่งไปอู่นอก / ศูนย์บริการ</Radio>
                        <Radio value='OUTSOURCE'>งานนอก (ช่างเบิกไปซ่อมข้างนอก)</Radio>
                      </Radio.Group>
                      <br />
                      {initialData.outsourceType === 'SERVICECENTER'
                        && <UI.Div>
                          <UI.Div display='flex' alignItems='center'>
                            <UI.P margin='24px 16px 16px 0'>ชื่อศูนย์บริการ *</UI.P>
                            <Select
                              showSearch
                              style={{ width: '40%' }}
                              loading={loading}
                              onSelect={(e) => {
                                const selected = _.find(garageData.GarageList.lists, o => o.name === e)
                                onChangeHandler('garageId', selected.id)
                                garageHandler.setGarageSelected(selected)
                              }}
                              onSearch={e => garageHandler.setGarageSearch(e)}
                              placeholder='พิมพ์เพื่อค้นหา'
                              disabled={disabled || initialData.status === status.COMPLETED}
                              defaultValue={!_.isNull(initialData.Garage) ? initialData.Garage.name : ''}
                            >
                              {
                                garageList.map(v => <Select.Option key={v.id} value={v.name}>{v.name}</Select.Option>)
                              }
                            </Select>
                          </UI.Div>
                          <UI.Div><UI.P margin='0 16px 16px 0'>เบอร์โทร</UI.P><UI.P>{_.isEmpty(garageHandler.garageSelected) ? !_.isNull(initialData.Garage) ? initialData.Garage.phoneNumber : '' : garageHandler.garageSelected.phoneNumber}</UI.P></UI.Div>
                          <UI.Div><UI.P margin='0 16px 16px 0'>ที่อยู่</UI.P><UI.P>{_.isEmpty(garageHandler.garageSelected)
                            ? !_.isNull(initialData.Garage) && !_.isNull(initialData.Garage.address)
                              ? initialData.Garage.address
                              : !_.isNull(initialData.Garage)
                                ? 'ไม่มีข้อมูลที่อยู่ของศูนย์บริการนี้'
                                : ''
                            : !_.isNull(garageHandler.garageSelected.address)
                              ? garageHandler.garageSelected.address
                              : 'ไม่มีข้อมูลที่อยู่ของศูนย์บริการนี้'}</UI.P></UI.Div>
                        </UI.Div>
                      }
                      <UI.Div margin={mutationVariables.outsourceType === 'SERVICECENTER' ? '0' : '16px 0 0 0'}><UI.P margin='0 16px 16px 0'>หมายเหตุ</UI.P><UI.Input disabled={disabled} defaultValue={!_.isNull(initialData.outsourceRemark) ? initialData.outsourceRemark : ''} width='50%' onChange={e => onChangeHandler('outsourceRemark', e.target.value)} /></UI.Div>
                    </UI.Div>
                  }}</Query>}
              </UI.Div>
            }
          </UI.Div>
        </Col>
      )
    case 11:
      return (
        <Col span={data.span} offset={data.offset}>
          {
            initialData.status === status.COMPLETED && <UI.Div display='flex' flexDirection='column' alignItems='flex-end'>
              <UI.H4 bold color={moment(initialData.closeDate).isAfter(moment(initialData.deadlineDate), 'day') ? theme.color.error : theme.color.success}>{moment(initialData.closeDate).isAfter(moment(initialData.deadlineDate), 'day') ? 'ช้ากว่ากำหนด' : 'ตรงตามกำหนด'}</UI.H4>
              <UI.P>วันที่ซ่อมเสร็จ: {moment(initialData.closeDate).format('DD MMMM YYYY')}</UI.P>
            </UI.Div>
          }
        </Col>
      )
    case 12:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Select
              style={{ width: '100%' }}
              onSelect={(e) => {
                onChangeHandler(data.id, e)
              }}
              defaultValue={initialData.status === 'PENDING'}
              disabled={disabled}
            >
              <Select.Option key={1} value={false}>รถเข้าอู่</Select.Option>
              <Select.Option key={2} value={true}>รถยังไม่เข้าอู่</Select.Option>
            </Select>
          </UI.Div>
        </Col>
      )
    case 13: {
      const {
        data: myInfo, loading, error, fetchMore, refetch,
      } = useQuery(MYINFO)
      if (loading || _.isEmpty(myInfo)) return <UI.Loading center='true' />
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Select
              defaultValue={initialData.Warehouse ? initialData.Warehouse.warehouseName : 'ไม่ระบุ'}
              style={{ width: '100%' }}
              disabled={disabled}
              onSelect={(e) => {
                onChangeHandler(data.id, e)
              }}
            >
              {
                myInfo.myInfo.Warehouses.map(v => <Select.Option key={v.id} value={v.id}>{v.warehouseName}</Select.Option>)
              }
            </Select>
          </UI.Div>
        </Col>
      )
    }
    case 14:
      return (
        <Col
          span={data.span} offset={data.offset}
          style={{ margin: data.props.margin }}
        >
          <UI.Div>
            <InputWithLabelBlock
              isFloat={true}
              data={{
                unit: data.unit,
                defaultValue: initialData[data.id],
                disabled,
                // value: disabled ? numeral(totalAmount).format('0,0.00') : totalAmount,
                id: data.id,
                props: { margin: '0 8px 16px 0', width: '100%', title: { text: data.label } },
              }}
              onChangeHandler={onChangeHandler}
            />
          </UI.Div>
        </Col>
      )
    case 14.1: {
      const cost = initialData.services ? _.reduce(initialData.services, (sum, n) => {
        if (n.serviceType === 'TIRE') return sum
        return _.reduce(n.ItemBorrows, (sumPrice, v) => {
          const amount = n.ItemReturns && _.find(n.ItemReturns, o => o.sku === v.sku)
            ? v.amount - _.find(n.ItemReturns, o => o.sku === v.sku).amount > 0
              ? v.amount - _.find(n.ItemReturns, o => o.sku === v.sku).amount
              : 0
            : v.amount
          return amount * v.pricePerItem + sumPrice
        }, 0)
      }, 0) : 0
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.P {...data.props} display='block' margin='0 0 16px'>{data.label}</UI.P>
          <UI.P {...data.props} display='block' padding='7px 0'>{numeral(cost).format('0,0.00')} บาท</UI.P>
        </Col>
      )
    }
    case 14.2: {
      const cost = initialData.services ? _.reduce(initialData.services, (sum, n) => {
        if (n.serviceType === 'NORMAL') return sum
        return sum + _.reduce(n.ItemBorrows, (sumPrice, v) => v.pricePerItem + sumPrice, 0)
      }, 0) : 0
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.P {...data.props} display='block' margin='0 0 16px'>{data.label}</UI.P>
          <UI.P {...data.props} display='block' padding='7px 0'>{numeral(cost).format('0,0.00')} บาท</UI.P>
        </Col>
      )
    }
    case 14.3: {
      const price = mutationVariables.price ? mutationVariables.price : initialData.price
      const expense = mutationVariables.expense ? mutationVariables.expense : initialData.expense
      const expenseTire = mutationVariables.expenseTire ? mutationVariables.expenseTire : initialData.expenseTire
      const partCost = initialData.services ? _.reduce(initialData.services, (sum, n) => {
        if (n.serviceType === 'TIRE') return sum
        return _.reduce(n.ItemBorrows, (sumPrice, v) => {
          const amount = n.ItemReturns && _.find(n.ItemReturns, o => o.sku === v.sku)
            ? v.amount - _.find(n.ItemReturns, o => o.sku === v.sku).amount > 0
              ? v.amount - _.find(n.ItemReturns, o => o.sku === v.sku).amount
              : 0
            : v.amount
          return amount * v.pricePerItem + sumPrice
        }, 0)
      }, 0) : 0
      const tireCost = initialData.services ? _.reduce(initialData.services, (sum, n) => {
        if (n.serviceType === 'NORMAL') return sum
        return sum + _.reduce(n.ItemBorrows, (sumPrice, v) => v.pricePerItem + sumPrice, 0)
      }, 0) : 0
      const cost = price + expense + expenseTire + partCost + tireCost
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.P {...data.props} display='block' margin='0 0 16px'>{data.label}</UI.P>
          <UI.P {...data.props} display='block' padding='7px 0'>{numeral(cost).format('0,0.00')} บาท</UI.P>
        </Col>
      )
    }
    case 15:
      return (
        <Col span={data.span} offset={data.offset} style={data.props.style}>
          <UI.Div>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Select
              style={{ width: '100%' }}
              onSelect={(e) => {
                onChangeHandler(data.id, e)
              }}
              disabled={
                disabled
                || !_.isUndefined(mutationVariables[data.enableKey]) ? !mutationVariables[data.enableKey] : !initialData[data.enableKey]
              }
              defaultValue={initialData[data.id]}
            >
              {Object.keys(repairJobType).map(type => (
                <Select.Option value={repairJobType[type].value} key={repairJobType[type].value}>
                  {repairJobType[type].label}
                </Select.Option>
              ))}
            </Select>
          </UI.Div>
        </Col>
      )
    case 16: {
      const enableKey = !_.isUndefined(mutationVariables[data.enableKey]) ? mutationVariables[data.enableKey] : initialData[data.enableKey]
      const enableOtherKey = !_.isUndefined(mutationVariables[data.enableOtherKey]) ? mutationVariables[data.enableOtherKey] : initialData[data.enableOtherKey]

      return (
        <Col span={data.span} offset={data.offset} style={data.props.style}>
          <UI.Div>
            <InputWithLabelBlock
              data={{
                disabled:
                  disabled
                  || !(
                    enableKey
                    && enableOtherKey === repairJobType.OTHER.value
                  ),
                value: mutationVariables[data.id],
                defaultValue: initialData[data.id],
                id: data.id,
                props: { margin: '0 8px 16px 0', width: '100%', title: { text: data.label } },
              }}
              onChangeHandler={onChangeHandler}
            />
          </UI.Div>
        </Col>
      )
    }
    case 17:
      return (
        <Col
          span={24}
          style={{
            height: '1px',
            width: '100%',
            backgroundColor: theme.color.paleGrey,
            marginBlock: '40px',
          }}
        />
      )
    case 18:
      return (
        <Col span={24}>
          <UI.P>ประเภทของการซ่อม</UI.P>
        </Col>
      )
    default:
      return <p>no type</p>
  }
}

export default ({
  data, mode, onChangeHandler, initialData, plateHandler, garageHandler, trailerHandler, mutationVariables,
}) => {
  switch (mode) {
    case detailMode.ADD:
      return <CreateMode data={data} plateHandler={plateHandler} garageHandler={garageHandler} mutationVariables={mutationVariables} onChangeHandler={onChangeHandler} trailerHandler={trailerHandler} />
    case detailMode.EDIT:
      return <EditMode data={data} initialData={initialData} onChangeHandler={onChangeHandler} plateHandler={plateHandler} garageHandler={garageHandler} mutationVariables={mutationVariables} trailerHandler={trailerHandler} />
    case detailMode.VIEW:
      return <EditMode data={data} disabled={true} initialData={initialData} onChangeHandler={onChangeHandler} plateHandler={plateHandler} garageHandler={garageHandler} mutationVariables={mutationVariables} trailerHandler={trailerHandler} />
    default:
      return <p>no mode</p>
  }
}
